import React from 'react';

import AlertBlock from '../../../common/AlertBlock';
import MobileTable from './MobileTable';

const MobileComponent = (props) => {
  const {
    Wrapper,
    data,
    loading,
    handleNewItem,
    handleRemoveItem,
    currentVariant,
    currentQuantityInput,
    currentQuantityInputValue,
    handleToggleQuantityInput,
    handleUpdateQuantity,
    setCurrentQuantityInputValue,
    setCurrentQuantityInput,
    TableWrap,
    isNew,
  } = props;
  return (
    <Wrapper className="card-box">
      <div className="row">
        <div className="col-12">
          <h4 className="header-title" style={{ marginBottom: '10px' }}>
            Состав комплекта
          </h4>
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <MobileTable
            data={data}
            creatable
            bottomCreateButton
            removable
            createLabel="+ Добавить товар в комплект"
            loading={loading}
            handleNewItem={handleNewItem}
            handleRemoveItem={handleRemoveItem}
            currentQuantityInput={currentQuantityInput}
            currentQuantityInputValue={currentQuantityInputValue}
            handleToggleQuantityInput={handleToggleQuantityInput}
            handleUpdateQuantity={handleUpdateQuantity}
            setCurrentQuantityInputValue={setCurrentQuantityInputValue}
            setCurrentQuantityInput={setCurrentQuantityInput}
            TableWrap={TableWrap}
            isNew={isNew}
          />
        </div>
      </div>
      {currentVariant?.isFfPhysicalSetSynchronized ? (
        <div className="row" style={{ marginTop: '15px' }}>
          <div className="col-12">
            <AlertBlock
              type="warning"
              message="Если комплект участвовал в заказе или сборочном задании, то его состав нельзя изменить"
            />
          </div>
        </div>
      ) : null}
    </Wrapper>
  );
};

export default MobileComponent;
